var Handlebars = require("/Users/mauricengo/styleguide-test/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "\n"
    + ((stack1 = container.invokePartial(require("/Users/mauricengo/styleguide-test/src/materials/modules/cta-buttons/preorder.html"),depth0,{"name":"cta-buttons.preorder","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\n<a href=\"./preorder-notify.html\" class=\"link link--bold u-text-lg u-margin-t--xxl u-margin-b--xl u-padding-t--md\">Notify Me When Available</a>\n";
},"usePartial":true,"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/materials/modules/cta-buttons/preorder-cart.html
// module id = 153
// module chunks = 0